var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 21.3333L9.95956 15.3737C10.4123 14.9211 11.0264 14.6667 11.6667 14.6667C12.307 14.6667 12.921 14.9211 13.3737 15.3737L18.6667 20.6667M18.6667 20.6667L20.6667 22.6667M18.6667 20.6667L21.2929 18.0404C21.7456 17.5877 22.3597 17.3333 23 17.3333C23.6403 17.3333 24.2544 17.5877 24.7071 18.0404L28 21.3333",
    stroke: "#9DA7FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 3.33333C10.361 3.33333 7.54118 3.33333 5.671 4.93062C5.40542 5.15743 5.15809 5.40477 4.93128 5.67034C3.33398 7.54053 3.33398 10.3604 3.33398 16C3.33398 21.6396 3.33398 24.4595 4.93128 26.3296C5.15809 26.5952 5.40542 26.8425 5.671 27.0693C7.54118 28.6667 10.361 28.6667 16.0007 28.6667C21.6403 28.6667 24.4601 28.6667 26.3303 27.0693C26.5959 26.8425 26.8432 26.5952 27.07 26.3296C28.6673 24.4595 28.6673 21.6396 28.6673 16",
    stroke: "#9DA7FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.666 7.33333C21.4524 6.52421 23.5456 3.33333 24.666 3.33333C25.7864 3.33333 27.8796 6.52421 28.666 7.33333M24.666 3.99999V12.6667",
    stroke: "#9DA7FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddImage);
export default __webpack_public_path__ + "static/media/iconAddImage.50baa7ca22e143970ab4f9948220d7a3.svg";
export { ForwardRef as ReactComponent };